/**
 * Created by jv on 2019-11-26 (13:37).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import htmlView from "Views/partials/game/game-progress-controller.html";
import LanguageManager from "Sources/services/language-manager";

import BusinessModel from "Sources/components/business-model/business-model";
import DefaultLayout from "Sources/components/business-model/layouts/default"; // %NOTE: CMS.faq also uses this config, please change there too :)

const eventIcons = require.context("!raw-loader!Images/icons/events", false, /\.svg$/);
const iconCardsReq = require.context("!raw-loader!Images/icons/cards", false, /\.svg$/);

require("Styles/components/game-progress-controller.scss");

class GameProgressView {
  constructor(options) {
    this.$container = $(options.container);

    this.businessModel = null;

    this.roundIndex = options.roundIndex;
    this.roundProgressMap = options.roundProgressMap;

    this.onRenderCompleted = options.onRenderComplete;
    this.executeOnRender = [];
  }

  get roundProgressMap() {
    return this._roundProgressMap;
  }

  set roundProgressMap(roundProgressMap) {
    this._roundProgressMap = roundProgressMap;
    this.setUpChangeRoundButtons();
  }

  get roundIndex() {
    return this._roundIndex;
  }

  set roundIndex(roundIndex) {
    this._roundIndex = roundIndex;
    this.setUpChangeRoundButtons();
  }

  render() {
    this.$element = $(htmlView);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.$businessModelCanvas = this.$element.find(".game-progress__canvas");

    this.showBusinessModelOnRender = true;
    this.setLoadingState(true);
    this.renderBusinessModelCanvas();

    this._setUpEventListeners();
  }

  onRender() {
    log.info("Business model has rendered");

    this.setUpChangeRoundButtons();
    this.update();

    if (this.showBusinessModelOnRender) {
      this.showBusinessModel(true, false);
      this.businessModel.fitToContainer();
    }

    for (let i = 0; i < this.executeOnRender.length; i++) {
      if (utils.isFunction(this.executeOnRender[i])) {
        this.executeOnRender[i].call(this);
      }
    }

    if (utils.isFunction(this.onRenderCompleted)) {
      this.onRenderCompleted.call(this);
    }
  }

  renderBusinessModelCanvas() {
    this.businessModel = new BusinessModel({
      containerElement: this.$businessModelCanvas,
      layoutData: DefaultLayout,
      onRenderComplete: this.onRender.bind(this),
      availableCanvasSize: (businessModel) => {
        let $overview = this.$element.find(".game-progress__overview");
        let $canvasWrapper = $overview.find(".game-progress__canvas-wrapper");
        let $roundSelector = $overview.find(".game-progress__round-selector");

        // Dirty hack to reset canvas size (otherwise it won't shrink anymore)
        $canvasWrapper.hide();
        let availableWidth = $overview.width() - $roundSelector.outerWidth(true);
        let availableHeight = $overview.height();
        $canvasWrapper.show();

        return {
          width: Math.min(businessModel.layoutData.size.width * 1.5, availableWidth),
          height: Math.min(businessModel.layoutData.size.height * 1.5, availableHeight)
        }
      },
      onCanvasSizeChanged: (oldWidth, oldHeight, newWidth, newHeight) => {
        log.info("Size changed: \noldWidth: %f\noldHeight: %f\nnewWidth: %f\nnewHeight: %f", oldWidth, oldHeight, newWidth, newHeight);
        this.$element.find(".game-progress__canvas-wrapper").css({
          width: newWidth,
          height: newHeight
        });
      }
    });

    log.info("Rendering business model: %o", this.businessModel);

    this.businessModel.render();
  }

  show() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.show();
    }
  }

  hide() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.hide();
    }
  }

  destroy() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.remove();
    }
  }

  showBusinessModel(flag) {
    if (flag) {
      if (this.businessModel.hasRendered()) {
        this.setLoadingState(false);
        this.$businessModelCanvas.show();
      } else {
        this.showBusinessModelOnRender = true;
        this.setLoadingState(true);
      }
    } else {
      this.$businessModelCanvas.hide();
    }
  }

  setLoadingState(flag) {
    if (flag) this.$element.addClass("gp__is-loading");
    else this.$element.removeClass("gp__is-loading");
  }

  setUpChangeRoundButtons() {
    // Determines if buttons are clickable or not

    if (utils.isNotNull(this.$element) && this.$element.length) {
      this.$element.find(".select-round-btn").each((index, el) => {
        let $el = $(el);
        let roundIndex = parseInt($el.data("gp-round-index"));

        $el.parent().removeClass("active");

        let clickable = this.canViewGameProgress(roundIndex);
        $el.prop("disabled", !clickable);

        if (clickable && roundIndex === this.roundIndex) {
          $el.parent().addClass("active");
        }
      });
    }
  }

  _setUpEventListeners() {
    this.$element.find(".select-round-btn").off("click").on("click", this.onChangeRoundEvent.bind(this));
  }

  update() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let roundProgress = this.roundProgressMap[this.roundIndex];

      if (utils.isNull(roundProgress)) {
        log.error("Round progress for round [%d] not found - %o", this.roundIndex, this.roundProgressMap);
        return false;
      }

      if (utils.isNull(roundProgress.roundData.closed)) {
        log.error("Can't view game progress for round that's not yet finished");
        return;
      }

      log.info("Applying game progress for round [%d]\nRound progress: %o", this.roundIndex, roundProgress);

      this.updateBusinessModel(roundProgress);
      this.updateData(roundProgress);
    }
  }

  updateBusinessModel(roundProgress) {
    // Update business model
    if (utils.isNotNull(this.businessModel) && this.businessModel.hasRendered()) {
      let currentInvestments = this.getAllCurrentInvestments();
      currentInvestments = currentInvestments.map(ti => ti.type);
      this.businessModel.setInvestments(currentInvestments);
      this.businessModel.income = roundProgress.roundData.currentIncome;

      let productIcon = roundProgress.productIcon;
      let extraProductIcon = roundProgress.extraProductIcon;

      if (utils.isNotNull(productIcon)) {
        this.businessModel.setCompanyIcon(productIcon);
      }

      if (utils.isNotNull(extraProductIcon)) {
        this.businessModel.setCompanyExtraProduct(extraProductIcon);
      }
    }
  }

  updateData(roundProgress) {
    // Budget / Points
    this.$element.find("[data-game-progress-round]").each((index, el) => {
      $(el).attr("data-game-progress-round", this.roundIndex).text(this.roundIndex);
    });

    this.$element.find("[data-game-progress-budget]").each((index, el) => {
      $(el).attr("data-game-progress-budget", roundProgress.roundData.currentBudget).text(roundProgress.roundData.currentBudget);
    });

    this.$element.find("[data-game-progress-points]").each((index, el) => {
      $(el).attr("data-game-progress-points", roundProgress.roundData.currentPoints).text(roundProgress.roundData.currentPoints);
    });

    // Event
    this.$element.find("[data-game-progress-event]").each((index, el) => {
      let eventType = utils.isNotNull(roundProgress.event) ? roundProgress.event.type : null;
      let $el = $(el);
      $el.attr("data-game-progress-event", utils.isNull(eventType) ? "" : eventType);

      $el.empty();

      if (utils.isNotNull(roundProgress.event)) {
        let $icon = $(`<div class="gp__event-icon">${GameProgressView.getEventIconForType(eventType)}</div>`);
        let $label = $(`<div class="gp__event-label">${roundProgress.event.title}</div>`);

        $el.append($icon).append($label);
      } else {
        $el.append(`<div class="gp__event-label mx-auto text-center">${LanguageManager.getValueForKey("teacher_platform.game_progress.data.no_event.label")}</div>`)
      }
    });

    // Investments
    this.$element.find("[data-game-progress-investment-1]").each((index, el) => {
      let investment1 = roundProgress.investments.find(i => i.key === roundProgress.roundData.investmentKey1);
      let investmentType = utils.isNotNull(investment1) ? investment1.type : null;
      let $el = $(el);
      $el.attr("data-game-progress-investment-1", utils.isNull(investmentType) ? "" : investmentType);

      $el.empty();

      if (utils.isNotNull(investment1)) {
        let $icon = $(`<div class="gp__investment-icon">${GameProgressView.getInvestmentIconForType(investmentType)}</div>`);
        $icon.addClass(`gp-investment__${investmentType}`);
        let $label = $(`<div class="gp__investment-label">${LanguageManager.getValueForKey(`serious_game.business_model.investments.front.titles.${investmentType}`)}</div>`);

        $el.append($icon).append($label);
      } else {
        $el.append(`<div class="gp__investment-label mx-auto text-center">${LanguageManager.getValueForKey("teacher_platform.game_progress.data.investment_not_used.label")}</div>`)
      }
    });

    this.$element.find("[data-game-progress-investment-2]").each((index, el) => {
      let investment2 = roundProgress.investments.find(i => i.key === roundProgress.roundData.investmentKey2);
      let investmentType = utils.isNotNull(investment2) ? investment2.type : null;
      let $el = $(el);
      $el.attr("data-game-progress-investment-2", utils.isNull(investmentType) ? "" : investmentType);

      $el.empty();

      if (utils.isNotNull(investment2)) {
        let $icon = $(`<div class="gp__investment-icon">${GameProgressView.getInvestmentIconForType(investmentType)}</div>`);
        $icon.addClass(`gp-investment__${investmentType}`);
        let $label = $(`<div class="gp__investment-label">${LanguageManager.getValueForKey(`serious_game.business_model.investments.front.titles.${investmentType}`)}</div>`);

        $el.append($icon).append($label);
      } else {
        $el.append(`<div class="gp__investment-label mx-auto text-center">${LanguageManager.getValueForKey("teacher_platform.game_progress.data.investment_not_used.label")}</div>`)
      }
    });
  }

  onChangeRoundEvent(e) {
    log.info("Clicked on change round button - %o", e);
    let $this = $(e.currentTarget);
    let roundIndex = parseInt($this.data("gp-round-index"));

    if (this.canViewGameProgress(roundIndex)) {
      this.$element.find(".game-progress__round-selector li.active").removeClass("active");
      $this.parent().addClass("active");

      if (utils.isNumber(roundIndex)) {
        this.roundIndex = roundIndex;
        this.update();
      }
    }
  }

  getAllCurrentInvestments() {
    let investments = [];

    for (let roundIndex in this.roundProgressMap) {
      if (roundIndex > this.roundIndex) break;

      if (this.roundProgressMap.hasOwnProperty(roundIndex)) {
        investments = investments.concat(this.roundProgressMap[roundIndex].investments);
      }
    }

    return investments;
  }

  canViewGameProgress(roundIndex) {
    if (utils.isNull(roundIndex) || !utils.isNumber(roundIndex) || utils.isNull(this.roundProgressMap) || !this.roundProgressMap.hasOwnProperty(roundIndex)) return false;

    let roundProgress = this.roundProgressMap[roundIndex];

    if (utils.isNull(roundProgress)) {
      log.error("Round progress for round [%d] not found - %o", roundIndex, this.roundProgress);
      return false;
    }

    return utils.isNotNull(roundProgress.roundData.closed);
  }

  static getEventIconForType(eventType) {
    let eventIconKey = `./${eventType}.svg`;
    if (eventIcons.keys().includes(eventIconKey)) {
      return eventIcons(eventIconKey);
    }

    return null;
  }

  static getInvestmentIconForType(investmentType) {
    let requireKey = `./${investmentType}.svg`;

    if (iconCardsReq.keys().includes(requireKey)) {
      return iconCardsReq(requireKey);
    }

    return null;
  }
}

module.exports = GameProgressView;



// WEBPACK FOOTER //
// ./app/js/controllers/game-progress-controller.js